// src/components/AppErrorBoundary.jsx
// Last-resort safety net around the whole app (see index.js). Without it, any
// error thrown while rendering - or in an effect - unmounts everything and
// leaves a blank white page with no clue what to do (how the 2026-09-27
// old-Chrome PDF crash looked to the student). Now they get a message and a
// Reload button instead. Nothing a student has already saved is affected -
// the exam answers autosave to Firestore independently of this page.

import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', background: '#f7fafc', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ maxWidth: '460px', background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', padding: '28px', textAlign: 'center' }}>
          <AlertTriangle size={36} color="#c33329" style={{ marginBottom: '12px' }} />
          <h1 style={{ fontSize: '19px', margin: '0 0 10px 0', color: '#2c3e50' }}>Something went wrong on this page</h1>
          <p style={{ fontSize: '14px', color: '#4a5568', lineHeight: 1.6, margin: '0 0 8px 0' }}>
            Your saved work is safe. Please reload the page to carry on.
          </p>
          <p style={{ fontSize: '14px', color: '#4a5568', lineHeight: 1.6, margin: '0 0 20px 0' }}>
            If this keeps happening, please update Google Chrome (Settings, then About Chrome) and try again, or let your tutor know.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 22px', background: '#c33329', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 700, fontSize: '14px', cursor: 'pointer' }}
          >
            <RefreshCw size={16} />
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
